import sls from 'react-secure-storage';

export const getCurrentLanguage = () => {
  const queryParams = new URLSearchParams(window.location.search);

  return queryParams.get('language') || localStorage.getItem('Language') || sls.getItem('slsHrMobileLanguage') || 'th';
};

export const saveLanguage = (lang) => {
  sls.setItem('slsHrMobileLanguage', lang);
  localStorage.setItem('Language', lang);
};
